import React, { useEffect, useState } from 'react';
import { useSportState } from '@apollo/core/src/state/sport/sport';
import cx from 'classnames';
import Dropdown from '../../../shared/components/Dropdown/Dropdown';
import { AnimatedDropdown } from '../../Animations/AnimatedDropdown';
import PrematchTournamentLink from './PrematchTournamentLink';
import { SportLink } from '../../../shared/components/Sport/SportLinks';
import Label from '../../../shared/components/I18n/Label';
import useScrollPage from '../../../shared/components/Dropdown/useScrollPage';
import { SportIcon } from '../../../shared/components/Sport/SportIcon';

const PrematchTournamentHeader = ({ tournament }) => {
  const [sportsState] = useSportState();
  const { selectedSportId, tournamentsByCategoryId, categoriesBySportId, selectedCategoryId } = sportsState;

  const sportCategories = categoriesBySportId && categoriesBySportId[selectedSportId];
  const [isShowCategories, setIsShowCategories] = useState(false);

  const firstTournaments = sportCategories
    && sportCategories.reduce((tournaments, category) => {
      const tournamentsByCategory = tournamentsByCategoryId[category.id];
      if (Array.isArray(tournamentsByCategory)) {
        const sortedTournaments = tournamentsByCategory.sort((prevTournament, nextTournament) => {
          if (prevTournament.position > nextTournament.position) {
            return 1;
          }
          if (prevTournament.position < nextTournament.position) {
            return -1;
          }
          if (prevTournament.name > nextTournament.name) {
            return 1;
          }
          if (prevTournament.name < nextTournament.name) {
            return -1;
          }
          return 0;
        });

        const firstTournament = sortedTournaments[0];

        return [...tournaments, firstTournament];
      }
      return tournaments;
    }, []);

  const isScroll = useScrollPage();

  useEffect(() => {
    if (isScroll) {
      setIsShowCategories(false);
    }
  }, [isScroll]);

  return (
    <Dropdown
      isExpanded={isShowCategories}
      onExpanded={setIsShowCategories}
      className='sport-page__header-dropdown'
    >
      <div className='sport-page__header'>
        <SportIcon id={tournament.sportId} name={tournament.sportName} />
        <h1
          className={cx(['sport-name', Array.isArray(sportCategories) && 'has-dropdown'], {
            expanded: isShowCategories,
          })}
        >
          {tournament.categoryName}
        </h1>
      </div>

      <AnimatedDropdown
        isExpanded={isShowCategories}
        className='tournament-list tournament-list__dropdown'
        endOverflow='auto'
      >
        <div className='tournament-list__item'>
          <SportLink className='tournament-list__all-link' sportUrlName={tournament.sportUrlName}>
            <Label className='tournament-list__all-label' message='view_all_tournaments' />
            {' '}
            {tournament.sportName}
          </SportLink>
        </div>
        {firstTournaments
          ? firstTournaments.map((tournament) => (
            <PrematchTournamentLink
              key={tournament.id}
              tournament={tournament}
              isActive={tournament.categoryId === selectedCategoryId}
            />
          ))
          : null}
      </AnimatedDropdown>
    </Dropdown>
  );
};
export default PrematchTournamentHeader;
